import { InstallationRefusal } from '@core/helpers/installation-refusal.helper';

export interface LocationUpdateRefusalMessage {
  key: string;
  params?: { installations: string };
}

const KEY_PREFIX = 'locations.updateDialog.';
const HOSTS_INSTALLATIONS = 'location_hosts_installations_needs_coordinates';
const SHARED_DEVICE_TIMEZONE = 'shared_device_timezone_conflict';
const NOT_SAVED = { key: KEY_PREFIX + 'notSaved' };

// The reason carries the names of the Active installations after the code
// ("location_hosts_installations_needs_coordinates: Horstlaan 24, Dorpsstraat 3"). The global
// snackbar is off for a 409 on this call, so any other 409 gets a generic message rather than
// nothing, and never its raw reason code.
export function locationUpdateRefusalMessage(
  refusal: InstallationRefusal,
): LocationUpdateRefusalMessage | null {
  const { status, reason } = refusal;
  if (status !== 409) {
    return null;
  }
  if (reason === null) {
    return NOT_SAVED;
  }
  const separator = reason.indexOf(':');
  const code = (separator === -1 ? reason : reason.slice(0, separator)).trim();
  if (code === SHARED_DEVICE_TIMEZONE) {
    return { key: KEY_PREFIX + 'sharedDeviceTimezone' };
  }
  if (code !== HOSTS_INSTALLATIONS) {
    return NOT_SAVED;
  }
  const installations = separator === -1 ? '' : reason.slice(separator + 1).trim();
  return installations
    ? { key: KEY_PREFIX + 'addressNotFoundHostsInstallations', params: { installations } }
    : { key: KEY_PREFIX + 'addressNotFound' };
}
